import { JSX, ReactElement } from "react";
import { FolderOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { MenuDto } from "src/dtos/menu/menuDto";

// PDA 컨테이너 import
import PDA1010_R01Container from "src/containers/PDA/PDA1010_R01/PDA1010_R01Container";
import PDA1020_R01Container from "src/containers/PDA/PDA1020_R01/PDA1020_R01Container";
import PDA1030_R01Container from "src/containers/PDA/PDA1030_R01/PDA1030_R01Container";
import PDA1040_R01Container from "src/containers/PDA/PDA1040_R01/PDA1040_R01Container";
import PDA1050_R01Container from "src/containers/PDA/PDA1050_R01/PDA1050_R01Container";
import PDA1060_R01Container from "src/containers/PDA/PDA1060_R01/PDA1060_R01Container";
import PDA1061_R01Container from "src/containers/PDA/PDA1061_R01/PDA1061_R01Container";
import PDA1120_R01Container from "src/containers/PDA/PDA1120_R01/PDA1120_R01Container";
import PDA1121_R01Container from "src/containers/PDA/PDA1121_R01/PDA1121_R01Container";
import PDA1122_R01Container from "src/containers/PDA/PDA1122_R01/PDA1122_R01Container";
import PDA1123_R01Container from "src/containers/PDA/PDA1123_R01/PDA1123_R01Container";
import PDA1130_R01Container from "src/containers/PDA/PDA1130_R01/PDA1130_R01Container";
import PDA1131_R01Container from "src/containers/PDA/PDA1131_R01/PDA1131_R01Container";
import PDA1110_R01Container from "src/containers/PDA/PDA1110_R01/PDA1110_R01Container";
import PDA1080_R01Container from "src/containers/PDA/PDA1080_R01/PDA1080_R01Container";
import PDA1070_R01Container from "src/containers/PDA/PDA1070_R01/PDA1070_R01Container";
import PDA1071_R01Container from "src/containers/PDA/PDA1071_R01/PDA1071_R01Container";
import PDA1072_R01Container from "src/containers/PDA/PDA1072_R01/PDA1072_R01Container";
import PDA1090_R01Container from "src/containers/PDA/PDA1090_R01/PDA1090_R01Container";
import PDA1100_R01Container from "src/containers/PDA/PDA1100_R01/PDA1100_R01Container";
import PDA1081_R01Container from "src/containers/PDA/PDA1081_R01/PDA1081_R01Container";
import PDA1091_R01Container from "src/containers/PDA/PDA1091_R01/PDA1091_R01Container";

/**
 * 메뉴 코드에 따라 컴포넌트를 반환하는 함수
 * @param menu 메뉴 정보
 * @param onBack 뒤로가기 핸들러
 * @returns React 컴포넌트 또는 null
 */
export const getMenuComponent = (
	menu: MenuDto,
	onBack: () => void
): ReactElement | null => {
	switch (menu.menuCd) {
		case "PDA1010_R01":
			return <PDA1010_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1020_R01":
			return <PDA1020_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1030_R01":
			return <PDA1030_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1040_R01":
			return <PDA1040_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1050_R01":
			return <PDA1050_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1060_R01":
			return <PDA1060_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1061_R01":
			return <PDA1061_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1070_R01":
			return <PDA1070_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1071_R01":
			return <PDA1071_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1072_R01":
			return <PDA1072_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
			case "PDA1080_R01":
				return <PDA1080_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1081_R01":
			return <PDA1081_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1090_R01":
			return <PDA1090_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1091_R01":
			return <PDA1091_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
			case "PDA1100_R01":
				return <PDA1100_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1120_R01":
			return <PDA1120_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1121_R01":
			return <PDA1121_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1122_R01":
			return <PDA1122_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1123_R01":
			return <PDA1123_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1130_R01":
			return <PDA1130_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1131_R01":
			return <PDA1131_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		case "PDA1110_R01":
			return <PDA1110_R01Container menuNm={menu.menuNm} menuCd={menu.menuCd} onBack={onBack} />;
		// 다른 메뉴 추가 시 여기에 case 추가
		default:
			// 아직 구현되지 않은 메뉴
			return (
				<div className="w-full h-full flex flex-col bg-white">
					<div className="w-full bg-blue-600 text-white px-4 py-3 flex items-center justify-between">
						<button onClick={onBack} className="mr-2">
							<ArrowLeftOutlined className="text-xl" />
						</button>
						<h1 className="text-lg font-medium flex-1">{menu.menuNm}</h1>
					</div>
					<div className="flex-1 flex items-center justify-center">
						<p className="text-gray-500 text-lg">준비 중입니다...</p>
					</div>
				</div>
			);
	}
};


// export const handleBookmarkMenuClick = (
//     menu: BookmarkCdList, 
//     tabList: Tab[], 
//     setActiveTab: (tab: Tab) => void, 
//     addTabList: (tab: Tab) => void
// ) => {
//     const exist = tabList.find(value => value.key === menu.key);
//     if (exist) {	
//         setActiveTab(exist);
//     } else {
//         const newTab = {
//             key: menu.key,
//             title: menu.name,
//             component: getMenuComponent(menu.key)
//         };
//         addTabList(newTab);
//         setActiveTab(newTab);
//     }
// };


	//메뉴 아이콘 설정
export const menuIcon_First = (menu: Partial<MenuDto> & { menuCd: string, menuNm: string }): JSX.Element => {
	const availableIcons = ['$$$', 'MST', 'ACC', 'TQC', 'HRM', 'SAL', 'SYS', 'EQM', 'PRD', 'WMS', 'PUR'];

	if (availableIcons.includes(menu.menuCd)) {
		return <img src={`${process.env.PUBLIC_URL}/MESICON/${menu.menuCd}.png`} alt={menu.menuCd.toLowerCase()} className="w-[20px] h-[20px] mr-2" />;
	} else {
		return <FolderOutlined style={{ color: '#ffffff', fontSize: '20px', marginRight: '4px' }} />;
	}
}
